var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("pdf-view"),
      _vm._v(" "),
      _c("VerReporte"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "blue--text" },
        [
          _c("v-icon", { attrs: { color: "blue" } }, [_vm._v("today")]),
          _vm._v(" Detalle refrigerio\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "py-0" },
        [
          _c(
            "v-card-text",
            { staticClass: "secondary py-0" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "p-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", row: "" } },
                        [
                          _c("v-flex", { attrs: { md6: "", xs12: "" } }, [
                            _c("strong", [_vm._v("DEPENDENCIA: ")]),
                            _vm._v(
                              _vm._s(this.persona.movilidad.unidad) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                            _c("strong", [_vm._v("SERVIDOR PÚBLICO: ")]),
                            _vm._v(
                              _vm._s(_vm.persona.nombres) +
                                "\n              " +
                                _vm._s(_vm.persona.ap_paterno) +
                                " " +
                                _vm._s(_vm.persona.ap_materno) +
                                "\n            "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", "justify-space-between": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido",
                                attrs: {
                                  type: "number",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label: "Gestión",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.listaDetalleRefrigerio()
                                  }
                                },
                                model: {
                                  value: _vm.form.gestion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "gestion", $$v)
                                  },
                                  expression: "form.gestion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c("v-autocomplete", {
                                staticClass: "text-field-reducido",
                                attrs: {
                                  items: _vm.meses,
                                  "item-value": "id",
                                  "item-text": "valor",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label: "Seleccionar mes",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.listaDetalleRefrigerio()
                                  }
                                },
                                model: {
                                  value: _vm.form.mes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "mes", $$v)
                                  },
                                  expression: "form.mes"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            row: "",
                            wrap: "",
                            "justify-space-between": ""
                          }
                        },
                        [
                          _c("v-flex", { attrs: { shrink: "" } }, [
                            _c("strong", [_vm._v("TOTAL DIAS DESCUENTO:")]),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.total_dias_descuento) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { shrink: "" } }, [
                            _c("strong", [_vm._v("TOTAL DIAS HABILES:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.total_dias_habiles) +
                                "\n            "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "primary py-0 px-2" },
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.l_refrigerio_detalle,
                  "no-data-text": _vm.loading
                    ? "Cargando..."
                    : "No se tiene registros",
                  "disable-initial-sort": true,
                  loading: _vm.loading,
                  "item-key": "index",
                  "rows-per-page-text": "Filas por pagina",
                  "rows-per-page-items": [10, 20, { text: "Todos", value: -1 }]
                },
                scopedSlots: _vm._u([
                  {
                    key: "headers",
                    fn: function(props) {
                      return [
                        _c(
                          "tr",
                          _vm._l(props.headers, function(header) {
                            return _c(
                              "th",
                              {
                                key: header.text,
                                class: [
                                  "column sortable",
                                  _vm.pagination.descending ? "desc" : "asc",
                                  header.value === _vm.pagination.sortBy
                                    ? "active"
                                    : ""
                                ],
                                attrs: { id: "cabecera_tabla" },
                                on: {
                                  click: function($event) {
                                    return _vm.changeSort(header.value)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(header.text) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    }
                  },
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(props.item.fecha)
                                  .format("dddd")
                                  .toUpperCase()
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(props.item.fecha)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(props.item.dias_descuento))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            props.item.loading != true
                              ? _c(
                                  "v-layout",
                                  {
                                    attrs: {
                                      "align-center": "",
                                      "justify-space-between": ""
                                    }
                                  },
                                  [
                                    _c(
                                      "table",
                                      { staticClass: "table-refrigerio" },
                                      [
                                        _vm._l(props.item.detalles, function(
                                          detalle
                                        ) {
                                          return _c(
                                            "tr",
                                            {
                                              key: detalle.index,
                                              style:
                                                detalle.descuenta > 0
                                                  ? "background:rgb(219, 62, 177,0.3"
                                                  : detalle.tipo_marcado == "I"
                                                  ? "background:rgb(252, 76, 2,0.3"
                                                  : ""
                                            },
                                            [
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: { width: "100%" }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(detalle.descripcion)
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        _vm._v(" "),
                                        props.item.detalles.length == 0
                                          ? _c("tr", [
                                              _vm._v(
                                                "\n                  -\n                "
                                              )
                                            ])
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79509269", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79509269","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asistencia/DetalleRefrigerioFuncionario.vue
// module id = null
// module chunks = 